import React from 'react';
import {
  AnnotationStandardDetails,
  FindingTypeDetails,
  FindingTypeProperty,
  FindingTypeRuleDetails
} from '../../AnnotationStandardForm/AnnotationStandardForm.slice';
import { CreateAnnotationProperty } from '../AnnotationForm/AnnotationForm.types';
import styles from '../AnnotationForm/AnnotationForm.module.scss';
import Busy from '../../../Shared/Busy';
import PropertyInput from '../AnnotationForm/Annotation/PropertyInput';

type Props = {
  annotationStandard: AnnotationStandardDetails | null;
  selectedFindingType: FindingTypeDetails | null;
  properties: CreateAnnotationProperty[];
  selectedProperties: FindingTypeProperty[];
  selectedRules: FindingTypeRuleDetails[];
  setProperties: (properties: CreateAnnotationProperty[]) => void;
};

const MultiselectProperties = ({ annotationStandard, properties, selectedFindingType, selectedProperties, selectedRules, setProperties }: Props) => {
  const nonLocalizationProperties = properties.filter(
    x => selectedFindingType?.representations.find(y => y.findingTypePropertyId === x.findingTypePropertyId)?.group !== 'Localization'
  );
  const generatePropertyInput = (property: CreateAnnotationProperty, index: number) => {
    var isLocalizationProperty =
      selectedFindingType?.representations.find(x => x.findingTypePropertyId === property.findingTypePropertyId)?.group === 'Localization';
    var propertyTemplate = selectedProperties.find(x => x.id === property.findingTypePropertyId);

    if (!isLocalizationProperty && propertyTemplate) {
      return (
        <PropertyInput
          key={property.findingTypePropertyId}
          propertyTemplate={propertyTemplate}
          group={nonLocalizationProperties}
          property={property}
          index={index}
          selectedRules={selectedRules}
          properties={[properties]}
          updateProperties={updatedProperties => {
            console.log(updatedProperties);
            setProperties([...updatedProperties[0]]);
          }} //lets check this
          isWarrantyCaseClosed={false}
        />
      );
    }
  };

  return (
    <>
      {selectedFindingType && (
        <>
          {!selectedProperties.length && (
            <div className={styles.iconSpinner}>
              <Busy />
            </div>
          )}
          <div className={styles.enabledRows}>{nonLocalizationProperties.map((property, index) => generatePropertyInput(property, index))}</div>
        </>
      )}
    </>
  );
};

export default MultiselectProperties;
